"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
class plantronics {
    constructor($http, XucLink, $log, $q, $interval, $rootScope) {
        this.$http = $http;
        this.XucLink = XucLink;
        this.$log = $log;
        this.$q = $q;
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.uid = undefined;
        this.sessId = undefined;
        this.state = "Uninitialized";
        this.pollingInterval = undefined;
        this.canRegisterSessId = true;
        this.retryTimeout = undefined;
        this.retryTimeoutSeconds = 2;
        this.retryTimeoutMax = 256;
        this.init = () => {
            this.$log.info("Starting Plantronics headset Service");
            this.tryRegistering();
        };
        this.uninit = () => {
            this.$log.info("Unloading Plantronics Service");
            if (this.retryTimeout)
                clearTimeout(this.retryTimeout);
            this.stopPolling().then(() => {
                this.uid = undefined;
                this.retryTimeoutSeconds = 2;
                this.state = "Uninitialized";
            });
        };
        this.registerXucLinkLoginHandler = () => {
            this.XucLink.whenLogged().then(() => {
                this.init();
                this.registerXucLinkLogoutHandler();
            });
        };
        this.registerXucLinkLogoutHandler = () => {
            this.XucLink.whenLoggedOut().then(() => {
                this.uninit();
                this.registerXucLinkLoginHandler();
            });
        };
        this.tryRegistering = () => {
            if (this.retryTimeoutSeconds <= this.retryTimeoutMax) {
                return this.registerUid().then(() => {
                    this.state = "Paused";
                }).catch(() => {
                    this.$log.warn(`Plantronics headset: Service initialization unsuccessfull. Retrying in ${this.retryTimeoutSeconds} seconds.`);
                    this.startRetryTimeout();
                });
            }
            else
                this.$log.warn(`Plantronics service could not reach headset in time. No more retries.`);
        };
        this.startRetryTimeout = () => {
            this.retryTimeout = setTimeout(this.tryRegistering, this.retryTimeoutSeconds * 1000);
            this.retryTimeoutSeconds *= 2;
        };
        this.registerUid = () => {
            if (angular_1.default.isDefined(this.uid)) {
                this.$log.debug("register plantronics Uid", this.uid);
                return this.$q.resolve(this.uid);
            }
            let url = "http://127.0.0.1:32017/Spokes/DeviceServices/Info";
            let promise = this.$http.jsonp(url, { jsonpCallbackParam: 'callback' });
            return promise.then((response) => {
                if (response.data.isError == true) {
                    return this.$q.reject(response.data.Err.Description);
                }
                this.uid = response.data.Result.Uid;
                return this.uid;
            }).catch((failedRequest) => {
                return this.$q.reject("Failing to register uid : " + JSON.stringify(failedRequest));
            });
        };
        this.getUid = () => {
            return this.uid;
        };
        this.registerSessId = () => {
            let url = "http://127.0.0.1:32017/Spokes/DeviceServices/Attach?uid=" + this.uid;
            if (!(angular_1.default.isDefined(this.sessId)) && this.canRegisterSessId) {
                this.$log.debug("register sessId", this.sessId);
                this.canRegisterSessId = false;
                let promise = this.$http.jsonp(url, { jsonpCallbackParam: 'callback' });
                return promise.then((response) => {
                    if (response.data.isError == true) {
                        return this.$q.reject(response.data.Err.Description);
                    }
                    this.sessId = response.data.Result;
                    this.canRegisterSessId = true;
                    return this.sessId;
                }).catch((failedRequest) => {
                    this.canRegisterSessId = true;
                    return this.$q.reject("failing to register sessId : " + JSON.stringify(failedRequest));
                });
            }
            return this.$q.reject("avoiding second sessId registration.");
        };
        this.getSessId = () => {
            return this.sessId;
        };
        this.startPolling = () => {
            if (this.state == "Paused") {
                this.registerSessId().then(() => {
                    return this.cleanupEvents();
                }).then(() => {
                    this.state = "Polling";
                    if (!angular_1.default.isDefined(this.pollingInterval)) {
                        this.pollingInterval = this.$interval(this.poll, 300);
                    }
                }).catch((errorMessage) => {
                    this.$log.warn("Plantronics error while start polling : " + errorMessage);
                });
            }
        };
        this.getPollingInterval = () => {
            return this.pollingInterval;
        };
        this.cleanupEvents = () => {
            let url = "http://127.0.0.1:32017/Spokes/DeviceServices/Events?sess=" + this.sessId + "&queue=0";
            return this.$http.jsonp(url, { jsonpCallbackParam: 'callback' });
        };
        this.stopPolling = () => {
            if (this.state == "Polling") {
                if (this.pollingInterval)
                    this.$interval.cancel(this.pollingInterval);
                this.pollingInterval = undefined;
                let url = "http://127.0.0.1:32017/Spokes/DeviceServices/Release?sess=" + this.sessId;
                return this.$http.jsonp(url, { jsonpCallbackParam: 'callback' }).finally(() => {
                    this.state = "Paused";
                    this.sessId = undefined;
                    return this.$q.resolve(this.state);
                });
            }
            return this.$q.resolve(this.state);
        };
        this.getState = () => {
            return this.state;
        };
        this.addHeadphoneEventHandler = (callback) => {
            return this.$rootScope.$on('HeadphoneEvent', (event, headphoneEventType) => {
                callback(headphoneEventType);
            });
        };
        this.poll = () => {
            this.$log.debug("Plantronics : polling event");
            let url = "http://127.0.0.1:32017/Spokes/DeviceServices/Events?sess=" + this.sessId + "&queue=0";
            let promise = this.$http.jsonp(url, { jsonpCallbackParam: 'callback' });
            return promise.then((response) => {
                if (response.data.isError) {
                    return this.$q.reject(response.data.Err);
                }
                else {
                    return this.keypressExtraction(response.data.Result);
                }
            }).catch((failedRequest) => {
                this.$log.error("Plantronics : Error while listening Events : " + JSON.stringify(failedRequest));
            });
        };
        this.keypressExtraction = (eventChain) => {
            for (let plantronicEvent of eventChain) {
                switch (plantronicEvent.Event_Name) {
                    case "Talk":
                        this.$rootScope.$emit('HeadphoneEvent', 'Main');
                        break;
                }
            }
        };
        this.registerXucLinkLoginHandler();
    }
}
exports.default = plantronics;
plantronics.$inject = ["$http", "XucLink", "$log", "$q", "$interval", "$rootScope"];
